webpackJsonp([4],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(38);

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5370698c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_office_haikus_md__ = __webpack_require__(39);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5370698c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_office_haikus_md__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('html',[_c('head'),_c('body',[_c('h1',[_vm._v("Office haikus")]),_vm._v(" "),_c('p',[_vm._v("Client is droning "),_c('br'),_vm._v("\nManagement are on my back "),_c('br'),_vm._v("\nI am hungover "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\nThe report is due "),_c('br'),_vm._v("\nI have not written it yet "),_c('br'),_vm._v("\nWe need an intern "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\nEach weekday morning "),_c('br'),_vm._v("\nA struggle toward lunchtime "),_c('br'),_vm._v("\nI want a sandwich "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\nMy inbox is full "),_c('br'),_vm._v("\nI'm not paid enough for this "),_c('br'),_vm._v("\nI think I'll delete")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.5ab259d84838fffd4b44.js